$('.csv-download-btn').click((e)=>{
    let clickedLink = $(e.target)
    clickedLink.removeClass('btn-primary').addClass('btn-success')
    clickedLink.addClass('disabled')
    clickedLink.html('CSV Download Requested')
});
